// Modules
import Lottie from 'react-lottie-player';
// Assets
import lottieJson from './LogoAnim.json';

export const LogoAnim = (props: any) => {
	return (
		<Lottie
			animationData={lottieJson}
			loop
			direction={1}
			play
			style={{ margin: 'auto', width: props.width ? props.width : 92, height: props.height ? props.height : 92 }}
			renderer='svg'
		/>
	);
};
